import { render, staticRenderFns } from "./ModalReturMarketplace.vue?vue&type=template&id=a5944a9c&scoped=true&"
import script from "./ModalReturMarketplace.vue?vue&type=script&lang=js&"
export * from "./ModalReturMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./ModalReturMarketplace.vue?vue&type=style&index=0&id=a5944a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5944a9c",
  null
  
)

export default component.exports